/**
 * Decide how to react when a *different* Elation patient chart is detected while
 * viewing a matched member's profile.
 *
 * - Default (`confirmEnabled === false`): auto-navigate straight into the new
 *   patient's matching flow — no confirmation modal.
 * - Opt-in (`confirmEnabled === true`): show the `SwitchPatientModal` and let
 *   the user confirm (Stay / Navigate) before switching.
 *
 * `candidate` is the detected patient from `useEhrPatientSwitch` (`null` when no
 * different patient is currently detected).
 *
 * @returns true when the caller should auto-navigate immediately (no modal).
 */
export function shouldAutoNavigateOnSwitch(
  confirmEnabled: boolean,
  candidate: unknown | null,
): boolean {
  return candidate != null && !confirmEnabled;
}
